<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <form
      @submit.prevent="handleSubmit(accept)"
      @input="datosModificados"
      class="form_PForm"
      ref="form"
    >
      <slot :validar="() => datosModificados()"></slot>
      <PRow>
        <PCol>
          <div class="buttons_PForm" :class="alignButtons" v-if="!readonly">
            <div class="itemsButtons_PForm" v-if="showCancel">
              <PButton @click="cancel" variant="secondary">
                {{ textCancel }}
              </PButton>
            </div>
            <div class="itemsButtons_PForm">
              <PButton variant="primary" type="submit">
                {{ textAction }}
              </PButton>
            </div>
          </div>
        </PCol>
      </PRow>
    </form>
  </ValidationObserver>
</template>
<script lang="ts">
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";

@Component({
  components: {
    ValidationObserver,
  },
})
export class PForm extends Vue {
  @Prop({ required: true }) value!: boolean;

  @Watch("value", { immediate: true })
  onChangeValue(): void {
    this.validadoLocal = this.value;
  }

  @Ref("observer") readonly observer!: any;
  @Prop({ required: false, default: "accept" }) action!: string;
  @Prop({ required: false, default: "Accept" }) textAction!: string;
  @Prop({ required: false, default: "Cancel" }) textCancel!: string;
  @Prop({ required: false, default: false }) readonly!: boolean;
  @Prop({ required: false, default: "center" }) buttonsAlign!: string;
  @Prop({ required: false, default: true }) showCancel!: string;

  validadoLocal = false;

  async datosModificados(): Promise<void> {
    if (this.observer) {
      this.$emit("submit", this.validadoLocal);
    }
  }

  get alignButtons(): string {
    return this.buttonsAlign;
  }

  cancel(): void {
    this.$emit("cancel", this.validadoLocal);
  }

  accept(): void {
    this.$emit("accept", this.action);
  }
}

export default PForm;
</script>
<style lang="scss" scoped>
.form_PForm span .row {
  align-items: center;
}

.buttons_PForm {
  margin: 1rem 0;
  display: flex;

  &.right {
    justify-content: flex-end;
  }

  &.center {
    justify-content: center;
  }
}

.itemsButtons_PForm {
  margin-left: 1rem;
  margin-right: 1rem;
}
</style>
